import React, { Component } from 'react';
import { changeColorTint } from '../../../styles/utils';

class StarMarker extends Component {
  render() {
    return (
      <div
        style={{
          color: '#e8cd02',
        }}
        className={`starMarker ${this.props.focused && 'focused'}`}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
      >
        ★
      </div>
    );
  }
}

export default StarMarker;
